import clsx from 'clsx';
import * as styles from './index.css';

export function SetupGuideNavContainer({
  link,
  isClickable,
  children,
  handleNavigation,
  isActive,
}: {
  link: string;
  isClickable: boolean;
  children: React.ReactNode;
  handleNavigation: (event: React.MouseEvent<HTMLAnchorElement>) => void;
  isActive?: boolean;
}) {
  if (isClickable) {
    return (
      <a
        className={clsx('main-nav__main-link', { 'main-nav__main-link--active': isActive ?? false }, styles.navLink)}
        href={link}
        onClick={(e) => handleNavigation(e)}
      >
        {children}
      </a>
    );
  }

  return <div>{children}</div>;
}
